import React, {useMemo} from "react";

export const CssMasonry = ({children, columnGap = "1rem", rowGap = "1.5rem", breakpoints = {350: 1, 650: 2, 900: 3}}) => {
    const style = useMemo(() => {
        const mediaQueries = Object.entries(breakpoints)
            .sort(([a], [b]) => parseInt(a, 10) - parseInt(b, 10))
            .map(([width, columns]) => `
                @media (min-width: ${width}px) {
                    .css-masonry-grid {
                        column-count: ${columns};
                    }
                }
            `).join('\n');

        return `
            .css-masonry-grid {
                column-count: 1;
                column-gap: ${columnGap};
            }
            .css-masonry-item {
                break-inside: avoid;
                margin-bottom: ${rowGap};
                width: 100%; /* Ensure items take full width of the column */
            }
            ${mediaQueries}
        `;
    }, [columnGap, rowGap, breakpoints]);

    return (
        <>
            <style>{style}</style>
            <div className="css-masonry-grid">
                {React.Children.map(children, child => (
                    <div className="css-masonry-item">{child}</div>
                ))}
            </div>
        </>
    );
};